import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
} from "@mui/material";
//Import from project
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { PageHeaderTitle, ButtonCreate } from "../../Utils/Component";
import ShiftForm from "../../Components/Shift/ShiftForm";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import LoadingPage from ".././../Utils/LoadingPage";
import ShiftAction from "../../Components/Shift/ShiftAction";
import useGetShift from "../../Hooks/useGetShift";
import useWithDimension from "../../Hooks/useWithDimension";

export default function Shift() {
  // Change Language
  const { t } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { loading, refetch, tableData } = useGetShift();
  const { width } = useWithDimension();

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/setting"}
        pageTitle={t("page_setting")}
        detailTitle={t("page_shift")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <ShiftForm
                open={open}
                setRefetch={refetch}
                dialogTitle={"Create"}
                handleClose={handleClose}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell className={t("class-name-header-title-start")}>
                  {t("thead_no")}
                </TableCell>

                <TableCell className={t("class-name-header-title")}>
                  {t("thead_khmer_name")}
                </TableCell>

                <TableCell className={t("class-name-header-title")}>
                  {t("thead_english_name")}
                </TableCell>

                <TableCell className={t("class-name-header-title")}>
                  {t("thead_remark")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0|| tableData?.length === undefined  ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className={"body-row"} key={index}>
                          <TableCell className="body-cell-start">
                            {index + 1}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.khName}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.enName}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.remark}
                          </TableCell>

                          <TableCell className="body-cell-end" align="right">
                            <ShiftAction editData={row} setRefetch={refetch} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
